import { useState } from "react"
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap"
import styles from "./WholesalerDropdown.module.scss"
import { useNavigate } from "react-router-dom"

const WholesalerDropdown = ({ options, setSelectedAction = () => {} }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const navigate = useNavigate()

  const toggle = () => setDropdownOpen((prevState) => !prevState)

  const handleSelect = (item) => {
    console.log("selected option", item)
    if (item === 'Edit') {
      navigate("/marketing-options/edit-coupon")
      return
    }
  }

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} className={styles.actionDropdown}>
      <DropdownToggle caret className={styles.dropdownButton}>
        Action
      </DropdownToggle>
      <DropdownMenu className={styles["drop-down-menu"]}>
        {options?.length > 0 ? (
          <>
            {options?.map((item, index) => (
              <DropdownItem key={index} className={styles["dropdown-item"]} onClick={() => handleSelect(item)}>
                {item}
              </DropdownItem>
            ))}
          </>
        ) : (
          <DropdownItem className={styles["dropdown-item"]}>
            No options
          </DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  )
}

export default WholesalerDropdown
